module.exports = __webpack_public_path__ + "img/39.7cf455b1.png";